import { SourceConfigurationsComponent } from './source-configurations.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CCMCSharedModule } from 'src/@ccmc/shared.module';
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { Role } from 'src/@ccmc/models/role';

const routes: Routes = [
  {
    path: 'source-configurations',
    component: SourceConfigurationsComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    data: {
      roles: [
        Role.ClientAdmin,
        Role.NxtsoftSales,
        Role.NxtsoftOp,
        Role.NxtsoftDev
      ]
    }
  }
];

@NgModule({
  declarations: [SourceConfigurationsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    CCMCSharedModule,
    KeyboardShortcutsModule.forRoot()
  ]
})
export class SourceConfigurationsModule {}
